import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import PromotedObjectFields from './PromotedObjectFields'

import { facebookRightUploadAdCampaignSelector } from '../../../../../../../modules/selectors/rights'

import { OUTCOME_APP_PROMOTION, OUTCOME_TRAFFIC } from '../../../../../../../constants/campaigns'

import useStepFormStyles from '../../../../../../../styles/common/stepForms'

const PromotedObjectStep = ({ formik }) => {
  const stepFormClasses = useStepFormStyles()
  const { t } = useTranslation()

  const campaign = useSelector(facebookRightUploadAdCampaignSelector)

  const stepTitle = useMemo(() => {
    const isOutcomeTraffic = campaign.objective === OUTCOME_TRAFFIC
    const isOutcomeAppPromotion = campaign.objective === OUTCOME_APP_PROMOTION

    if (isOutcomeTraffic) {
      return t('Are we able to track landing page views?')
    } else if (isOutcomeAppPromotion) {
      return t('Select an app to promote')
    } else {
      return t('Select a conversion event to optimise towards')
    }
  }, [t, campaign.objective])

  return (
    <>
      <div className={stepFormClasses.stepTitle}>{stepTitle}</div>
      <div className={stepFormClasses.stepBody}>
        <PromotedObjectFields formik={formik} />
      </div>
    </>
  )
}

export default PromotedObjectStep
